import React from 'react';
import { AuthenticateWithRedirectCallback } from '@clerk/react-router';
import { FullScreenLoader } from '../../components/FullScreenLoader/FullScreenLoader';

export default function SsoCallback() {
  return (
    <>
      <AuthenticateWithRedirectCallback
        signInUrl="/auth"
        fallbackRedirectUrl="/"
      />
      <FullScreenLoader />
    </>
  );
}
